export interface WorkplaceInterface {
    name: string,
    value: number
}

export interface WorkplaceObjectInterface {
    ALL: WorkplaceInterface,
    YOUNGIN: WorkplaceInterface,
    MIRYANG: WorkplaceInterface,
    ASAN: WorkplaceInterface,
    DAMYANG: WorkplaceInterface,
}


export interface SearchTypeInterface {
    title: string,
    content: string,
    creator: string,
    name: string,
    author: string,
    publisher: string,
}

export interface SortTypeInterface {
    lastly: string,
    hitCount: string,
    onSale: string,
    soldOut: string,
}

interface ConstanceInterface {
    sortType: SortTypeInterface;
    api: any,
    workplace: any,
    searchType: SearchTypeInterface,
    noteType: any
    workplaceNameMap: any,
    boardNameMap: any,
    emotionList: any,
    cookieName: any
}

export const constance: ConstanceInterface = {
    api: {
        getUser: '/api/get-user',
        logIn: '/api/login',
        logOut: '/api/logout',
        getUserList: '/api/get-user-list',
        /* 문화포럼 일정 */
        getCultureForumCalendar: '/api/get-culture-forum-calendar',
        createCultureForumCalendar: '/api/create-culture-forum-calendar',
        /* 문화포럼 */
        getCultureForum: '/api/get-culture-forum',
        createCultureForum: '/api/create-culture-forum',
        /* 댓글 */
        deleteForumReplay: '/api/delete-forum-replay',
        getReplyList: '/api/get-reply-list',
        createReply: '/api/create-reply',
        updateReply: '/api/update-reply',
        deleteReply: '/api/delete-reply',
        /* 게시물 */
        imageUploadUrl: '/api/image-upload',
        createPost: '/api/create-post',
        getPostView: '/api/get-post-view',
        getPostList: '/api/get-post-List',
        deletePost: '/api/delete-post',
        updatePost: '/api/update-post',
        /* 비밀번호 */
        changePassword: '/api/change-password',
        resetPassword: '/api/reset-password',
        /* 동호회 */
        saveClub: '/api/save-club',
        getClubList: '/api/get-club-list',
        deleteClub: '/api/delete-club',
        /* 부서모임 */
        getDepartmentList: '/api/get-department-list',
        /* 도서 관리 */
        saveBook: '/api/save-book',
        getBookList: '/api/get-book-list',
        deleteBook: '/api/delete-book',
        applyBookRental: '/api/apply-book-rental',
        /* 도서관리 신청 */
        getBookApplicationList: '/api/get-book-application-list',
        getBookApplicationDetailList: '/api/get-book-application-detail-list',
        saveBookApplication: '/api/save-book-application',
        deleteBookApplication: '/api/delete-book-application',
        updateBookApplication: '/api/update-book-application',
        /* 쪽지 관리 */
        saveNote: '/api/save-note',
        getNoteList: '/api/get-note-list',
        deleteNote: '/api/delete-note',
        readNote: '/api/read-note',

        /* 출석 */
        getAttendanceList: '/api/get-attendance-list',

        /* 감정 */
        updateEmotion: '/api/update-emotion',

        /* 이벤트 당첨 체크*/
        checkWinningEvent: '/api/check-attendance-winning',

        /* 안 읽은 받은 쪽지 */
        getUnReadCount: '/api/get-unread-count',

        /* 메인페이지 게시물 리스트 */
        getRecentPostList: '/api/get-recent-post-list',

        /* 공지 리스트 */
        getNoticeList: '/api/get-notice-list',

        /* 평가자 */
        saveEvaluator: '/api/save-evaluator',
        deleteEvaluator: '/api/delete-evaluator',
        getEvaluatorList: '/api/get-evaluator-list',
        approveBestFriends: '/api/approve-best-friends',

        /* 플리마켓 */
        getFleaMarketList: '/api/get-flea-market-list',
        saveFleaMarket: '/api/save-flea-market',
        updateFleaMarket: '/api/update-flea-market',
        deleteFleaMarket: '/api/delete-flea-market',
        closeFleaMarket: '/api/close-flea-market',
    },
    workplaceNameMap: {
        0: '전체',
        10: '용인',
        20: '아산',
        30: '밀양',
        60: '담양',
    },
    boardNameMap: {
        all: '전체',
        suggestedTopic: '주제제안',
        afp: '발표신청',
        'department-meeting': '부서게시판',
        club: '동호회',
        'book-report': '독후감',
        free: '자유게시판',
        suggest: '건의합니다',
        event: '사내소식',
        bestFriends: '베스트 프렌즈',
        suninNews: '선인의 추억',
        employeeAssociation: '사우회',
        share: '나눔',
        fleaMarket: '플리마켓',
        menu: '식단표',
        retirementPensionEducation: '퇴직연금 교육',
        informationProtectionEducation: '정보보호 교육',
        notice: '공지',
        faq: '자주 묻는 질문',
    },
    workplace: {
        ALL: {
            name: '전체',
            value: 0,
        },
        YOUNGIN: {
            name: '용인',
            value: 10,
        },
        MIRYANG: {
            name: '아산',
            value: 20,
        },
        ASAN: {
            name: '밀양',
            value: 30,
        },
        DAMYANG: {
            name: '담양',
            value: 60,
        },
    },
    searchType: {
        title: 'title',
        content: 'content',
        creator: 'creator',
        name: 'name',
        author: 'author',
        publisher: 'publisher'
    },
    sortType: {
        lastly: 'lastly',
        hitCount: 'hitCount',
        onSale: "onSale",
        soldOut: "soldOut"
    },
    noteType: {
        appreciation: 'appreciation',
        normal: 'normal',
        sentInbox: 'sent-inbox',
        inBox: 'inbox'
    },
    emotionList: [
        {id: 'emotion-0', value: '😍', users: [],},
        {id: 'emotion-1', value: '😀', users: [],},
        {id: 'emotion-2', value: '😊', users: [],},
        {id: 'emotion-3', value: '😆', users: [],},
        {id: 'emotion-4', value: '😲', users: [],},
        {id: 'emotion-5', value: '😢', users: [],},
    ],
    cookieName: {
        attendanceWinningEvent: 'attendanceWinningEvent'
    }
};
